import Icon, { IconProps } from "@mui/material/Icon";
import Logo from "../../assets/img/logo.png";

const ChatProfile = ({ ...props }: IconProps) => {
  return (
    <Icon {...props}>
      <img className="flex h-full w-full" src={Logo} alt="logo" />
    </Icon>
  );
};

export default ChatProfile;
